'use strict';

angular.module('atex.dam').controller('DamPublishingSchedulesModalController', ['$scope', '$modal', '$timeout', '$rootScope', '$q', 'ContentService', 'DamTemplateService', 'DamService', 'configuration','DamConfigurationService', '$translate', 'DamStatusService', 'DamMarkAsService','DamNotificationService', 'UIConfigurationService', 'DamSchedulingService',
  function($scope, $modal, $timeout, $rootScope, $q, ContentService, DamTemplateService, DamService, configuration, DamConfigurationService, $translate, DamStatusService, DamMarkAsService, DamNotificationService, UIConfigurationService, DamSchedulingService) {
    $scope.panelTitle = $scope.model.isNew ? $translate.getTranslationTable().__PUBLISHING_SCHEDULE_NEW_DLG_TITLE__ : $translate.getTranslationTable().__PUBLISHING_SCHEDULE_MODIFY_DLG_TITLE__;
    $scope.message = $scope.model.message;
    $scope.field = { "value" : {} };
    $scope.publicationModel = { "set" : [] };
    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.isValid = false;
    $scope.article = atex.Content();

    //Todo not a part of phase 1
    $scope.entries = ['Daily','Weekly', 'Monthly', 'Mon-Fri', 'Mon-Sat'];
    $scope.pubDateOffsets = [0,1,2,3,4,5,6,7,8,9,10];
    $scope.frequency = "";

    $scope.templateTypes = [];
    $scope.timeSlots =[];

    $scope.availableTimezones = Object.values(moment.tz._names);
    $scope.publications =[];
    $scope.publication ={};

    $scope.article.data.aspects = {
      "contentData": {
        "data": {
          "_type": "atex.dam.standard.PublishingSchedule"
        }
      },
      "p.InsertionInfo": {
        "data": {
          "_type": "p.InsertionInfo"
        }
      },
      "atex.Metadata": {
        "data":{
          "_type": "atex.Metadata",
          "taxonomyIds": ['p.StandardCategorization'],
          "metadata": {
            "_type": "com.polopoly.metadata.Metadata",
            "dimensions": []
          }
        }
      }
    };


    $scope.primarySiteTemplate ={
      "id": "dam.map.picker",
      "dataBindings": [
        {
          "name": "primarySite",
          "widget": "pSecurityParent",

          "config": {
            "editable": true,
            "depth": 1,
            "excludedSites" : ["dam.d"]
          },
          "validators" : {
            "required": { "message": "You must select a Primary Site" }
          },

          "domainObjects": {
            "data":"p.InsertionInfo/securityParentId",
            "associatedSites": "p.InsertionInfo/associatedSites",
            "taxonomyIds": "atex.Metadata/taxonomyIds"
          }
        }
      ]
    };

    $scope.datePickerTemplate = {
      "id": "dam.pubdate.picker",
      "dataBindings": [
        {
          "name" : "publicationDate",
          "widget": "pDateTimePicker",
          "config": {
            "dtConfig": {
              "locale":"en-gb",
              "format": "DD/MM/YYYY HH:mm"
            },
            "editable" : true
          },
          "domainObjects": {
            "data": "contentData/scheduleDateAndTime"
          }
        }
      ]
    };


    //load publications
    var lookups = DamConfigurationService.getSearchLookups();
    if (lookups && lookups['publications']) {
      $scope.publications = lookups['publications'];
    }

    DamTemplateService.loadCreateContentTemplates().then(function(templates) {
      UIConfigurationService.filter("create-new", "desk-create-new",templates).then(function(_templates){
        $scope.templateTypes = _templates;
      }).then(DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        $scope.currentUserInfo = currentUserInfo;
        var template = 'atex.dam.standard.PublishingSchedule';

        DamTemplateService.getTemplateById(template).then(function (template) {

          $scope.template = angular.copy(template);
          $scope.article.template = $scope.template;

          if ($scope.model.isNew === true) {
            var guessedTimeZone = moment.tz.guess();
            atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/timeZone").value = guessedTimeZone ? guessedTimeZone : undefined;
            $scope.loaded = true;
            $scope.items = [];
          } else {
            DamSchedulingService.getSchedulingContent($scope.model.id).then(function (response) {
              $scope.reload(response);
              $scope.loaded = true;
            }).then(null, function (error) {
              $scope.showSpinner = false;
              var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            });
          }
        }).then(null, function (error) {
          $scope.showSpinner = false;
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }));
    });

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    function submit(cleanData) {
      $scope.showSpinner = true;
      if ($scope.model.isNew) {
        DamSchedulingService.createSchedule(cleanData).then(function (response) {
          $scope.showSpinner = false;
          response.data.aspects.contentData.data.id = response.id;
          $scope.$parent.doOk(response);
        }).then(null, function (error) {
          $scope.showSpinner = false;
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      } else {
        var updateInfo = {id: $scope.article.id, data: cleanData, revision: $scope.article.revision};
        DamSchedulingService.updateSchedule(updateInfo).then(function (response) {
          DamSchedulingService.getSchedulingContent(response.id).then(function (folder) {
            $scope.showSpinner = false;
            $scope.$parent.doOk(folder);
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }
    }

    $scope.updateArticleState = function () {
      $scope.showSpinner = true;
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/objectType").value = "publishingSchedule";
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/_type").value = "atex.dam.standard.PublishingSchedule";
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/items").value = $scope.items;
      $scope.article.data.aspects.contentData.data.contentSecurityParentId =  $scope.article.data.aspects["p.InsertionInfo"].data.securityParentId;

      //todo figure a different way to achieve this? if not, remove the other bit from planning service
      $scope.article.data.aspects["p.InsertionInfo"].data.securityParentId = "externalid/dam.assets.common.d";

      delete $scope.article.data.aspects.contentData.data.items_element_types;
      atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/items").forEach(function (item) {
        item.templateType = item.templateType.id;
        delete item.id;
      });

      delete $scope.article.data.aspects.contentData.data.id;
      delete $scope.article.data.aspects.contentData.data.id_element_types;

      var json = angular.toJson($scope.article.data);
      var cleanData = angular.fromJson(json);
      delete cleanData.aspects.contentData.data.items_element_types;
      return cleanData;
    };

    $scope.reload = function (response) {

        $scope.article = angular.copy(response);

        if ($scope.article.data.aspects.contentData.data.contentSecurityParentId !== undefined) {
          $scope.article.data.aspects["p.InsertionInfo"].data.securityParentId = $scope.article.data.aspects.contentData.data.contentSecurityParentId;
        }

        $scope.items = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/items");
        $scope.items.forEach(function ( item) {
          item.templateType = $scope.getTemplate(item.templateType);

          if (item.timeSlot !== undefined) {
            $scope.timeSlots.push(item.timeSlot);
          } else {
            $scope.timeSlots.push($translate.getTranslationTable().__PUBLISHING_SCHEDULE_ASAP_OPTION__);
          }

        });
    };

    $scope.doSave = function () {
      var cleanData = $scope.updateArticleState();
      submit(cleanData);
    };

    $scope.checkIfValid = function () {
      var name = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/name");
      var publication = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/publication");
      var site = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/p.InsertionInfo/data/securityParentId");

      if (name && publication && site) {
        $scope.isValid = true;
      } else {
        $scope.isValid = false;
      }
    };

    $scope.initCallback = function () {
    };

    $scope.changeStartCallback = function () {
    };

    $scope.isOkEnabled = function () {
      return !$scope.showSpinner && $scope.isValid && $scope.dirty;
    };

    $scope.onChange = function () {
      $scope.dirty = true;
      $scope.checkIfValid();
    };

    $scope.addNewPlanningItem = function () {
      var modalScope = $rootScope.$new(true);
      modalScope.model = {
        "isNew" : true,
        "templateTypes" : $scope.templateTypes
      };

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-publishing-schedule-item-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (response) {

        response.templateType = $scope.getTemplate(response.templateType);
        if (response.timeSlot  && response.timeSlot.ontime !== undefined) {
          var timeString = moment(response.timeSlot.ontime, "x").format("HH:mm");
          $scope.timeSlots.push(timeString);
          var date= moment(response.timeSlot.ontime);
          date.tz($scope.article.data.aspects.contentData.data.timeZone, true).format("HH:mm Z");
          response.timeSlot = date.tz($scope.article.data.aspects.contentData.data.timeZone, true).format("HH:mm");

        } else {
          $scope.timeSlots.push($translate.getTranslationTable().__PUBLISHING_SCHEDULE_ASAP_OPTION__);
        }

        $scope.items.push(response);
        $scope.dirty=true;
        $scope.checkIfValid();
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $scope.message.success
        }),false);
        destroyModal();
      };
    };


    $scope.cancel = function () {
      $scope.$parent.doCancel($scope.items);
    };

    $scope.editExistingPlanningItem = function (key, id) {

      var modalScope = $rootScope.$new(true);
      modalScope.isNew = false;

      modalScope.model = {
        "isNew" : false,
        "id" : id,
        "planningItem" : $scope.items[key],
        "templateTypes" : $scope.templateTypes
      };

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-publishing-schedule-item-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (response) {

        response.templateType = $scope.getTemplate(response.templateType);

        if (response.timeSlot !== undefined && response.timeSlot.ontime !== undefined) {
          $scope.timeSlots[key] = moment(response.timeSlot.ontime, "x").format("HH:mm");
          var date= moment(response.timeSlot.ontime);
          response.timeSlot = date.tz($scope.article.data.aspects.contentData.data.timeZone, true).format("HH:mm");
        } else {
          $scope.timeSlots[key] = $translate.getTranslationTable().__PUBLISHING_SCHEDULE_ASAP_OPTION__;
        }

        $scope.items[key] = response;
        $scope.dirty=true;
        $scope.checkIfValid();
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $scope.message.success
        }),false);
        destroyModal();
      };
    };

    $scope.editDefault = function ( key, id) {

      var modalScope = $rootScope.$new(true);
      modalScope.model = {
        "isNew" : $scope.items[key].defaultTemplateContentId === undefined,
        "types" : $scope.templateTypes,
        "templateId" : $scope.items[key].templateType.id,
        "parentContent" :  $scope.article,
        "id" : $scope.items[key].defaultTemplateContentId
      };

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-publishing-schedule-default-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doOk = function (response) {

        $scope.items[key].defaultTemplateContentId = response.id;
        $scope.dirty=true;
        $scope.checkIfValid();
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $scope.message.success
        }),false);
        destroyModal();
      };
    };

    $scope.delete = function (key) {
      var item =  $scope.items[key];
      if (item.defaultTemplateContentId) {
        DamSchedulingService.deleteDefault($scope.items[key].defaultTemplateContentId).then(function () {
          $scope.items.splice(key, 1);
          if (!$scope.model.isNew) {
            var cleanData = $scope.updateArticleState();
            var updateInfo = {id: $scope.article.id, data: cleanData, revision: $scope.article.revision};
            DamSchedulingService.updateSchedule(updateInfo).then(function (response) {
              DamSchedulingService.getSchedulingContent(response.id).then(function (plan) {
                $scope.reload(plan);
                $scope.showSpinner = false;
                DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $scope.message.success}), true);
              });
            }).then(null, function (error) {
              $scope.showSpinner = false;
              var message = $scope.message.error + " (" + error.cause + ")";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            });

          }
        });
      } else {
        $scope.items.splice(key, 1);
        if (!$scope.model.isNew) {
          var cleanData = $scope.updateArticleState();
          var updateInfo = {id: $scope.article.id, data: cleanData, revision: $scope.article.revision};
          DamSchedulingService.updateSchedule(updateInfo).then(function (response) {
            DamSchedulingService.getSchedulingContent(response.id).then(function (plan) {
              $scope.reload(plan);
              $scope.showSpinner = false;
              DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $scope.message.success}), true);
            });
          }).then(null, function (error) {
            $scope.showSpinner = false;
            var message = $scope.message.error + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        }
      }
    };

    $scope.setSelectedRow = function (row) {
      $scope.selectedRow = row;
    };

    $scope.getTemplate = function (template) {

      for (var i=0; i < $scope.templateTypes.length; i++) {
        var type = $scope.templateTypes[i];
        if (type.id === template) {
          return type;
        }
      }
    };

    $scope.isOwner = function (entry) {
      return true;
    };
    $scope.canShare = function (entry) {
      return $scope.isOwner(entry);
    };
    $scope.canEdit = function (entry) {
      return $scope.isOwner(entry);
    };
    $scope.canDelete = function (entry) {
      return $scope.isOwner(entry);
    };
    $scope.isInherited = function (entry) {
      return entry.isInherited;
    };

    $scope.changeEndCallbackPrimarySite = function (data) {
      $scope.article.data.aspects["p.InsertionInfo"].data.securityParentId = data.aspects["p.InsertionInfo"].data.securityParentId;
      $scope.article.data.aspects["p.InsertionInfo"].data.associatedSites = data.aspects["p.InsertionInfo"].data.associatedSites;
      $scope.article.data.aspects["atex.Metadata"].taxonomyIds = data.aspects["atex.Metadata"].data.taxonomyIds;
      $scope.dirty = true;
      $scope.checkIfValid();
      if(!$scope.$$phase) {
        $scope.$digest();
      }
      return;
    };

    $scope.changeEndCallbackScheduleDate = function (data) {
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/scheduleDateTime").value = data.aspects.contentData.data.scheduleDateAndTime;
      $scope.dirty = true;
      $scope.checkIfValid();
      if(!$scope.$$phase) {
        $scope.$digest();
      }
      return;
    };

  }]);